class PaginationFormatterService {
  constructor({ isCursor = false } = {}) {
    this._isCursor = isCursor;
  }

  /**
   * @param {Object} options
   * @param {Object} options.params
   * @param {Number} [options.params.max_registers] - The number of items to return per page
   * @param {Number} [options.params.page] - The number of pagination
   *
   * @param {Number} [options.params.page_size] - The number of items to return per page
   * @param {Number} [options.params.pageSize] - The number of items to return per page
   * @param {String} [options.params.page_cursor] - The base64 token to be used as a cursor
   * @param {String} [options.params.pageCursor] - The base64 token to be used as a cursor
   *
   * @param {Number} [options.maxRegisters] - The DEFAULT number of items to return per page
   */
  formatRequest({ params = {}, maxRegisters = 45 } = {}) {
    if (!this._isCursor) {
      return {
        max: params.max_registers || maxRegisters,
        startIn: params.page || 0
      };
    }

    return {
      pageSize: params.page_size || params.pageSize || maxRegisters,
      cursor: params.page_cursor || params.pageCursor
    };
  }

  /**
   * @param {Object} [response] - The api-db response object
   */
  formatResponse(response = {}) {
    if (!this._isCursor) {
      return {
        data: response?.items || response?.data || [],
        metadata: {
          pagination: {
            itemsPerPage: response?.metadata?.pagination?.itemsPerPage || 0,
            totalItems: response?.metadata?.pagination?.totalItems || 0
          }
        }
      };
    }

    return {
      items: response?.items || response?.data || [],
      meta: {
        first: response?.meta?.first || null,
        next: response?.meta?.next || null,
        previous: response?.meta?.previous || null,
        last: response?.meta?.last || null
      }
    };
  }
}

module.exports = PaginationFormatterService;
